import type { PipeTransform } from "@angular/core";
import { inject, Pipe } from "@angular/core";
import { TranslocoService } from "@jsverse/transloco";

import { ItemsLanguages } from "../../app/api/packbo/models/items-languages";
import { DirectusTranslationService } from "../i18n/directus-translation.service";

@Pipe({
    name: "pathFromItem",
    pure: false
})
export class PathFromItemPipe implements PipeTransform {
    private readonly translocoService = inject(TranslocoService);
    private readonly directusTranslationService = inject(DirectusTranslationService);
    public transform<
        T extends { translations_refs?: U[] | null },
        U extends { languages_code?: string | ItemsLanguages | null } | number
    >(item: number | T | null | undefined, type: "category" | "page" | "supplier"): string {
        if (typeof item !== "object" || !item) {
            return "";
        }

        if (!item.translations_refs || !Array.isArray(item.translations_refs)) {
            return "";
        }

        const translationsRefs = item.translations_refs;

        let slugTranslation = this.directusTranslationService.getTranslation(translationsRefs, "slug");

        const languageCode = this.translocoService.getActiveLang();

        if (type === "page") {
            if (!slugTranslation) {
                return "";
            }
            return `/${languageCode}/${slugTranslation}`;
        } else if (type === "supplier") {
            const directoryPathSegment = this.translocoService.translate("directoryPathSegment");
            const supplierPathSegment = this.translocoService.translate("supplierPathSegment");
            slugTranslation = this.directusTranslationService.getTranslation(item.translations_refs, "slug");
            return `/${languageCode}/${directoryPathSegment}/${supplierPathSegment}/${slugTranslation}`;
        } else if (type === "category") {
            const directoryPathSegment = this.translocoService.translate("directoryPathSegment");
            const categoryPathSegment = this.translocoService.translate("categoryPathSegment");
            return `/${languageCode}/${directoryPathSegment}/${categoryPathSegment}/${slugTranslation}`;
        }

        return "";
    }
}
